export default __webpack_public_path__ + "static/media/palabras.d9cbd02b.png";